Alerts = require 'app/scripts/views/lib/alerts'
{ Analytics } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
Backgrounds = require 'app/scripts/data/backgrounds'
{ BoardBackground } = require 'app/scripts/models/BoardBackground'
{ featureFlagClient } = require '@trello/feature-flag-client'
ModelLoader = require 'app/scripts/db/model-loader'
SelectBackgroundView = require 'app/scripts/views/board-menu/select-background-view'
SelectCustomBackgroundView = require 'app/scripts/views/board-menu/select-custom-background-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
{ dontUpsell } = require '@trello/config'
productPromoDisableOverlay = require 'app/scripts/views/templates/product_promo_disable_overlay'
boardChangeBackground = require 'app/scripts/views/templates/board_change_background'
BoardAddToTeam = require 'app/scripts/views/board-menu/board-add-to-team-view'

module.exports = class ChangeBoardBackgroundView extends View
  viewTitleKey: 'change background'

  className: 'board-menu-content-frame'

  events:
    'click .js-bg-colors': 'openBackgroundColors'
    'click .js-bg-photos': 'openBackgroundPhotos'
    'change .js-upload-image': 'setUploadImage'

  initialize: ({ @sidebarView }) ->
    super
    @makeDebouncedMethods 'render', 'renderCustomBackgrounds'

    @listenTo Auth.me().boardBackgroundList, 'change add remove reset', @renderCustomBackgroundsDebounced
    @listenTo @model, 'cancel-add-to-team', =>
      @addToTeam = false
      @render()

    if Auth.me().isFeatureEnabled('customBoardBackgrounds') || @model.getOrganization()?.isFeatureEnabled('customBoardBackgrounds')
      ModelLoader.loadMemberCustomBackgrounds(Auth.myId()).done()

    return

  fillBackgroundList: ($target, bgs, viewType = SelectBackgroundView) ->
    $target.find('.js-select-background:not(.js-uploader)').remove()
    @appendSubviews(@subview(viewType, bg, { board: @model }) for bg in bgs, $target)
    return

  render: ->
    @$el.empty()

    data = @model.toJSON()
    data.enabled_customBoardBackgrounds = Auth.me().isFeatureEnabled('customBoardBackgrounds') || @model.getOrganization()?.isFeatureEnabled('customBoardBackgrounds')
    data.idMember = Auth.myId()
    data.upsellEnabled = !dontUpsell

    if @addToTeam
      ModelLoader.loadMyOrganizations()

      @$el.parent().addClass('no-padding')
      @appendSubview @subview(BoardAddToTeam, @model, {
        menuType: "Change Background"
      })
    else
      @$el.html(boardChangeBackground(data))

      @renderCustomBackgrounds()
    @

  renderCustomBackgrounds: ->
    hasCustomBoardBackgrounds = Auth.me().isFeatureEnabled('customBoardBackgrounds') || @model.getOrganization()?.isFeatureEnabled('customBoardBackgrounds')
    $customList = @$('.js-custom-list')

    if !hasCustomBoardBackgrounds
      $customList.append(
        productPromoDisableOverlay()
      )

    else
      me = @modelCache.get('Member', Auth.myId())
      customBackgrounds = (
        me.boardBackgroundList.chain()
          .filter (background) -> background.get('type') == 'custom'
          .sortBy('id')
          .reverse()
          .value()
      )
      @fillBackgroundList $customList, customBackgrounds, SelectCustomBackgroundView

      # Move the uploader to the top
      $customList.find('.js-uploader').prependTo($customList)

    @

  uploadBackgroundsAndAddPreviews: (files) ->
    for file, i in files
      do (i) =>
        reader = new FileReader()
        data = { file }

        if !Util.validFileSize(file)
          Alerts.flash('file too large', 'error')
          return

        fd = new FormData()
        fd.append('token', Auth.myToken())
        fd.append('file', file)

        reader.onload = (file) =>
          @modelCache.get('Member', Auth.myId()).boardBackgroundList.create {
            type: 'custom'
            fullSizeUrl: file.target.result
          }, {
            data: fd
            processData: false
            contentType: false
            error: (model) =>
              model.set('error', 'Failed')
              @setTimeout ->
                model.destroy()
              , 5000
            success: (bgModel) =>
              board = @model
              # Update the local data so we don't have to wait for the server to respond
              _.extend(board.attributes.prefs, {
                backgroundColor: bgModel.get('color')
                backgroundImage: bgModel.get('fullSizeUrl')
                backgroundImageScaled: bgModel.get('scaled')
                backgroundTile: bgModel.get('tile')
                backgroundBrightness: bgModel.get('brightness')
              })

              board.setPref "background", bgModel.id
          }

        reader.readAsDataURL(file)

  setUploadImage: (e) ->
    Util.stop(e)
    $file = @$('.js-upload-image')

    track("Board Menu", "Upload Custom Background")
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendTrackEvent
        action: 'uploaded'
        actionSubject: 'boardBackground'
        actionSubjectId: 'customBoardBackground'
        source: 'boardMenuDrawerBackgroundScreen'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id || ''

    if !$file.prop('files')? && $file.val()
      # Yuck, it's IE.  Let's submit the form.
      Util.uploadFile Auth.myToken(), $file, ->
      return

    files = $file[0].files
    if files.length > 0
      @uploadBackgroundsAndAddPreviews(files)

    return

  openBackgroundColors: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'backgroundColors', component: 'colors'
    return

  openBackgroundPhotos: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'backgroundPhotos', component: 'photos'
    return
